var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: _vm.label1,
              nomeAba: _vm.nomeAba,
              obrigatorio: _vm.pratica[_vm.nomeArraySalvar].length === 0,
              rulesInput:
                _vm.pratica[_vm.nomeArraySalvar].length === 0 ? "required" : "",
              multiSelect: false,
              opcoes: _vm.optionsSelect,
              widthColumn: 8
            },
            model: {
              value: _vm.especieFlorestal,
              callback: function($$v) {
                _vm.especieFlorestal = $$v
              },
              expression: "especieFlorestal"
            }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules:
                _vm.pratica[_vm.nomeArraySalvar].length === 0 ? "required" : "",
              name: _vm.nomeAba + "/" + _vm.label2
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: _vm.label2,
                            obrigatorio:
                              _vm.pratica[_vm.nomeArraySalvar].length === 0
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          attrs: { name: _vm.label2, placeholder: "(m)" },
                          model: {
                            value: _vm.espacamento,
                            callback: function($$v) {
                              _vm.espacamento = $$v
                            },
                            expression: "espacamento"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("div", { staticClass: "mb-1" }, [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    disabled: _vm.disableButton,
                    round: "",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.addEspecie()
                    }
                  }
                },
                [_vm._v("\n        Adicionar\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.especieFlorestal === "OUTROS"
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  mode: "lazy",
                  name: _vm.nomeAba + "/Outra espécie florestal"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("Label", {
                                attrs: { label: _vm.label3, obrigatorio: true }
                              }),
                              _vm._v(" "),
                              _c("el-input", {
                                class: { "input erro": errors.length },
                                attrs: { name: "Outra espécie florestal" },
                                model: {
                                  value: _vm.outraEspecieFlorestal,
                                  callback: function($$v) {
                                    _vm.outraEspecieFlorestal = $$v
                                  },
                                  expression: "outraEspecieFlorestal"
                                }
                              }),
                              _vm._v(" "),
                              errors[0]
                                ? _c("span", { staticClass: "help erro" }, [
                                    _vm._v(" " + _vm._s(errors[0]))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  639086944
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.dados.length > 0
        ? _c("el-row", { attrs: { gutter: 20 } }, [
            _c(
              "div",
              { staticClass: "flex-wrapper row" },
              _vm._l(_vm.dados, function(e, i) {
                return _c(
                  "div",
                  { key: i + e.especie },
                  [
                    _c("Card", {
                      attrs: {
                        objeto: {
                          especie: _vm.nomeEspecie(e),
                          nomeCientifico: e.nomeCientifico,
                          espacamento: e.espacamento,
                          especificacao: e.especificacao
                        },
                        deletar: function() {
                          return _vm.rmEspecie(e)
                        },
                        editar: function() {
                          return _vm.editarEspecie(e)
                        },
                        titulo: _vm.tituloCard,
                        widthCard: "400px"
                      }
                    })
                  ],
                  1
                )
              }),
              0
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ecb52b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecb52b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/EspecieEspacamento/EspecieEspacamento.vue
// module id = null
// module chunks = 